class CartCountdown extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'cart-urgency-deadline';
  }

  connectedCallback() {
    this.timerElement = this.querySelector('[data-countdown]');
    if (!this.timerElement) return;

    const minutes = parseInt(this.dataset.minutes, 10) || 10;
    let deadline = null;
    try {
      deadline = parseInt(sessionStorage.getItem(this.storageKey), 10);
    } catch (e) {
      // sessionStorage unavailable (e.g. blocked storage) — timer lasts this pageview only
    }

    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + minutes * 60 * 1000;
      try {
        sessionStorage.setItem(this.storageKey, deadline);
      } catch (e) {
        // ignore
      }
    }

    this.deadline = deadline;
    this.render();
    this.interval = setInterval(this.render.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  render() {
    const remaining = this.deadline - Date.now();

    if (remaining <= 0) {
      this.expire();
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    this.timerElement.textContent = `${minutes}:${seconds}`;
  }

  expire() {
    if (this.interval) clearInterval(this.interval);
    this.interval = null;

    try {
      sessionStorage.removeItem(this.storageKey);
    } catch (e) {
      // ignore
    }

    this.classList.add('cart-urgency--expired');
    const label = this.querySelector('[data-timer-label]');
    if (label) label.remove();
    if (this.dataset.expiredText) {
      this.timerElement.textContent = this.dataset.expiredText;
      this.timerElement.removeAttribute('aria-hidden');
    }
  }
}

customElements.define('cart-countdown', CartCountdown);
